"use strict"; // Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass.js");

var _assertThisInitialized = require("/opt/build/repo/node_modules/@babel/runtime/helpers/assertThisInitialized.js");

var _get = require("/opt/build/repo/node_modules/@babel/runtime/helpers/get.js");

var _inherits = require("/opt/build/repo/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/opt/build/repo/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var messaging_1 = require("@phosphor/messaging");

var signaling_1 = require("@phosphor/signaling");

var widgets_1 = require("@phosphor/widgets");

var ReactDOM = __importStar(require("react-dom"));
/**
 * Phosphor widget that encodes best practices for VDOM based rendering.
 */


var VDomRenderer = /*#__PURE__*/function (_widgets_1$Widget) {
  _inherits(VDomRenderer, _widgets_1$Widget);

  var _super = _createSuper(VDomRenderer);

  function VDomRenderer() {
    var _this;

    _classCallCheck(this, VDomRenderer);

    _this = _super.apply(this, arguments);
    _this._modelChanged = new signaling_1.Signal(_assertThisInitialized(_this));
    return _this;
  }
  /**
   * A signal emitted when the model changes.
   */


  _createClass(VDomRenderer, [{
    key: "modelChanged",
    get: function get() {
      return this._modelChanged;
    }
    /**
     * Set the model and fire changed signals.
     */

  }, {
    key: "model",
    get:
    /**
     * Get the current model.
     */
    function get() {
      return this._model;
    }
    /**
     * Dispose this widget.
     */
    ,
    set: function set(newValue) {
      if (this._model === newValue) {
        return;
      }

      if (this._model) {
        this._model.stateChanged.disconnect(this.update, this);
      }

      this._model = newValue;

      if (newValue) {
        newValue.stateChanged.connect(this.update, this);
      }

      this.update();

      this._modelChanged.emit(void 0);
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this._model = null;

      _get(_getPrototypeOf(VDomRenderer.prototype), "dispose", this).call(this);
    }
    /**
     * Called to update the state of the widget.
     *
     * The default implementation of this method triggers
     * VDOM based rendering by calling the this.render() method.
     */

  }, {
    key: "onUpdateRequest",
    value: function onUpdateRequest(msg) {
      var vnode = this.render();

      if (Array.isArray(vnode)) {
        ReactDOM.render(vnode, this.node);
      } else {
        ReactDOM.render(vnode, this.node);
      }
    }
    /* Called after the widget is attached to the DOM
     *
     * Make sure the widget is rendered, even if the model has not changed.
     */

  }, {
    key: "onAfterAttach",
    value: function onAfterAttach(msg) {
      messaging_1.MessageLoop.sendMessage(this, widgets_1.Widget.Msg.UpdateRequest);
    }
  }]);

  return VDomRenderer;
}(widgets_1.Widget);

exports.VDomRenderer = VDomRenderer;
/**
 * Phosphor widget that renders React Element(s).
 *
 * All messages will re-render the element.
 */

var ReactElementWidget = /*#__PURE__*/function (_VDomRenderer) {
  _inherits(ReactElementWidget, _VDomRenderer);

  var _super2 = _createSuper(ReactElementWidget);

  /**
   * Creates a Phosphor widget that renders the element(s) `es`.
   */
  function ReactElementWidget(es) {
    var _this2;

    _classCallCheck(this, ReactElementWidget);

    _this2 = _super2.call(this);
    _this2._es = es;
    return _this2;
  }

  _createClass(ReactElementWidget, [{
    key: "render",
    value: function render() {
      return this._es;
    }
  }]);

  return ReactElementWidget;
}(VDomRenderer);

exports.ReactElementWidget = ReactElementWidget;
/**
 * Concrete implementation of VDomRenderer model.
 */

var VDomModel = /*#__PURE__*/function () {
  function VDomModel() {
    _classCallCheck(this, VDomModel);

    /**
     * A signal emitted when any model state changes.
     */
    this.stateChanged = new signaling_1.Signal(this);
    this._isDisposed = false;
  }
  /**
   * Test whether the model is disposed.
   */


  _createClass(VDomModel, [{
    key: "isDisposed",
    get: function get() {
      return this._isDisposed;
    }
    /**
     * Dispose the model.
     */

  }, {
    key: "dispose",
    value: function dispose() {
      if (this.isDisposed) {
        return;
      }

      this._isDisposed = true;
      signaling_1.Signal.clearData(this);
    }
  }]);

  return VDomModel;
}();

exports.VDomModel = VDomModel;